import ValueSplash_BMWHONOLULU from './ValueSplash_BMWHONOLULU.jpg';
import ValueSplash_MINIHAWAII from './ValueSplash_MINIHAWAII.jpg';

export const images = {
    ValueSplash_BMWHONOLULU,
    ValueSplash_MINIHAWAII,
};
